import { render, staticRenderFns } from "./ConfirmationDialogProvider.vue?vue&type=template&id=ae2041d4"
import script from "./ConfirmationDialogProvider.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialogProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports